import { Editor as Editors } from 'primereact/editor';  

const Editor = ({...rest}) => {

    return (
        <Editors {...rest} />
    )

};

export default Editor;